import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 님의 추정 평가금액 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 투자 원금 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 평가 손익 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 더보기 ")

import {getFormattedDate} from '@/utils/filters'
import {AgBoxS, AgIconS} from '@/components/ag'
import {toRef, computed, onMounted} from 'vue'
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  props: {
  investAmount: {default: 0, type: Number},
  investProfit: {default: 0, type: Number},
  name: {default: 'unknown', type: String},
  profitRate: {default: 0, type: Number},
  refreshDate: {default: '11.11', type: String},
},
  setup(__props) {

const props = __props

const store = useStore()
const router = useRouter()

const userName = toRef(props, 'name')
const refreshDate = toRef(props, 'refreshDate')
const formattedRefreshDate = computed(() => {
  return getFormattedDate(refreshDate.value, 'MM.DD')
})
const investAmount = toRef(props, 'investAmount')
const investProfit = toRef(props, 'investProfit')
const currentAmount = computed(() => {
  return investAmount.value + investProfit.value
})
const profitType = computed(() => {
  if (investProfit.value === 0) {
    return 0
  }
  return investProfit.value > 0 ? 1 : -1
})
const profitColor = computed(() => {
  switch(profitType.value) {
    case -1:
      return 'sky1'
    case 1:
      return 'red1'
    default:
      return 'gray3'
  }
})
const profitRate = toRef(props, 'profitRate')
onMounted(() => {
  store.dispatch('stockItem/ACT_GET_POPULARITY')
  store.dispatch('asset/loadData')
  store.dispatch('asset/ACT_GET_ASSET_PARTNERSHIPS')
})

return (_ctx: any,_cache: any) => {
  return (_unref(investAmount) > 0)
    ? (_openBlock(), _createBlock(_unref(AgBoxS), {
        key: 0,
        css: {dp: 'flex'}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {dp: 'flex', grow: '1', direction: 'column'} }, {
            default: _withCtx(() => [
              _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'row'} }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AgBoxS), { css: {typography: 'tit18b'} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(userName)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AgBoxS), { css: {typography: 'tit18b', fontWeight: '400'} }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {typography: 'main12r', color: 'gray3'} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(formattedRefreshDate)) + " 시장가 기준 ", 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {dp: 'flex'} }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AgBoxS), { css: {typography: 'num30eb'} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.currency(parseInt(_unref(currentAmount)))), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AgBoxS), { css: {typography: 'num30eb', fontWeight: '400'} }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {dp: 'flex'} }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AgBoxS), { css: {color: 'gray3', typography: 'main13r', mr: 8} }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AgBoxS), { css: {typography: 'main13r'} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.currency(parseInt(_unref(investAmount)))), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'row'} }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AgBoxS), { css: {color: 'gray3', typography: 'main13r', mr: 8} }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AgBoxS), {
                    css: {color: _unref(profitColor), typography: 'main13r'}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(profitType) > 0 ? '+' : '') + _toDisplayString(_ctx.$filters.currency(parseInt(_unref(investProfit)))) + " (" + _toDisplayString(_unref(profitRate) ? _unref(profitRate) : 0) + "%) ", 1)
                    ]),
                    _: 1
                  }, 8, ["css"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {dp: 'flex', justifyContent: 'flex-end', direction: 'column'} }, {
            default: _withCtx(() => [
              _createVNode(_unref(AgBoxS), {
                css: {dp: 'flex', alignItems: 'center', cursor: 'pointer'},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/tabs/mypage-myasset')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AgBoxS), null, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AgIconS), { name: "chevronForward" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})